// extracted by mini-css-extract-plugin
module.exports = {"lightCalendar":"LrvCalendar_lightCalendar__2GNCw","darkCalendar":"LrvCalendar_darkCalendar__1chY1"};